module.exports = __webpack_public_path__ + "static/media/svg-3.c1c40e5c.svg";